export default __webpack_public_path__ + "static/media/arrow-square-left.75a2b5ce.svg";